import React, { useState } from "react";
import { withRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import { Button, InfoMessage, PhoneNumberInput, TitleSubtitle } from "../..";
import { ButtonContainer, ButtonIcon, ButtonLabel, CTABackAndForthContainer } from "../../../pages/Register/Register.styles";
import { PhoneNumberContainer } from "./PhoneNumber.styles";
import { useRegisterContext } from "../../../contexts/RegisterContext";
import { sendConfirmPhoneNumberSMS } from "../../../services/AuthenticationService";
import { SendConfirmPhoneNumberSMSInterface } from "../../../models/Register";

interface PhoneNumberProps extends WithRouterProps {
    onNextButtonClick: Function;
    onPrevButtonClick: Function;
}

const PhoneNumber: React.FC<PhoneNumberProps> = ({
    onNextButtonClick,
    onPrevButtonClick
}) => {
    const { registerInfo, setRegisterInfo } = useRegisterContext();
    const [sendVerificationcodeError, setSendVerificationcodeError] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState<boolean>(false);

    const handleSendVerificationcode = () => {
        setLoading(true);
        const confirmPhoneNumberData = {
            email: registerInfo.user.email,
            phoneNumber: registerInfo.user.phoneNumber
        } as SendConfirmPhoneNumberSMSInterface
        sendConfirmPhoneNumberSMS(confirmPhoneNumberData).then((res) => {
            if (res.status == 400) {
                setSendVerificationcodeError(true);
                setErrorMessage(res.errors?.message ? res.errors?.message : "An error occured");
            } else if (res.status == 200) {
                onNextButtonClick();
            }
            setLoading(false);
        });
    }

    return (
        <PhoneNumberContainer>
            <TitleSubtitle
                size="sm"
                title="Mobile Number"
                subTitle="You will need to reply to an automated SMS to confirm your seat in the studio." />
            <div data-cy="register-phone-number" style={{ alignSelf: "stretch" }}>
                <PhoneNumberInput
                    value={registerInfo.user.phoneNumber}
                    onChange={(value) => setRegisterInfo(prevRegisterInfo => ({
                        ...prevRegisterInfo,
                        user: {
                            ...prevRegisterInfo.user,
                            phoneNumber: value
                        }
                    }))}
                    defaultCountry="AU"
                    inputProps={{
                        name: 'phone',
                        required: true,
                        autoFocus: true
                    }}
                />
            </div>
            {sendVerificationcodeError && (
                <InfoMessage
                    data-cy="register-error"
                    variant="error"
                    hasBackground={true}
                    message={errorMessage}
                />
            )}
            <CTABackAndForthContainer>
                <Button
                    size="md"
                    variant="tertiary"
                    onClick={() => onPrevButtonClick()}
                    data-cy="button-booking-next"
                    sx={{ padding: 0 }}
                >
                    <ButtonContainer>
                        <ButtonIcon icon="ArrowLeft" />
                        <ButtonLabel>Back</ButtonLabel>
                    </ButtonContainer>
                </Button>
                <Button
                    data-cy="register-phone-number-submit"
                    onClick={handleSendVerificationcode}
                    disabled={!registerInfo.user.phoneNumber}
                    loading={loading}
                > Send Verification Code </Button>
            </CTABackAndForthContainer>
        </PhoneNumberContainer>
    );
};

PhoneNumber.displayName = "PhoneNumber";

const ComponentWithRouter = withRouter(PhoneNumber)

export { ComponentWithRouter as PhoneNumber };
